import moment from "moment";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-hot-toast";
import downarrow from "../../assets/downarrow.png";
import uparrow from "../../assets/uparrow.png";
import DeleteCard from "../../Components/Cards/DeleteCard/DeleteCard";
import Circular_Form from "../../Components/Forms/Cicular/Circular_Form";
import { useSearch } from "../../context/SearchContext";
import api from "../../utils/api";
import "./Circular.css";

const Circular = () => {
  const { search } = useSearch(); // Search context
  const [display1, setDisplay1] = useState(0);
  const [del, setDel] = useState(0);
  const [delId, setDelId] = useState(0);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(new Date());
  const [sortBy, setSortBy] = useState("asc");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  const handleClick1 = () => {
    setIsEdit(false);
    setEditData({});
    setDisplay1(1);
  };

  // Fetch circulars from API
  const fetchCirculars = async () => {
    try {
      const response = await api.get(
        `/circulars?search=${search}&page=${pagination.page}&limit=${pagination.limit}`
      );
      setData(response?.data?.data);
      setPagination(response?.data?.pagination);
    } catch (err) {
      console.error("Failed to fetch circulars:", err);
      toast.error("Failed to fetch circulars");
    }
  };

  // Handle page change for pagination
  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  // Fetch circulars when search, page, or limit changes
  useEffect(() => {
    fetchCirculars();
  }, [search, pagination.page, pagination.limit]);

  // Only sort when sortBy changes, not when data changes
  const sortedData = React.useMemo(() => {
    // Defensive copy
    const arr = [...data];
    return arr?.sort((a, b) => {
      // Use moment for robust date comparison
      const dateA = moment(a.created);
      const dateB = moment(b.created);
      return sortBy === "asc" ? dateA - dateB : dateB - dateA;
    });
  }, [data, sortBy]);

  // Delete circular
  const handleDelete = async (id) => {
    await api.delete(`/circulars/${id}`);
    setDel(0);
    toast.success("Circular deleted successfully");
    fetchCirculars();
  };

  // Filter by date
  const handleFilter = async () => {
    const formattedDate = moment(startDate).format("YYYY-MM-DD");
    await api
      .get(`/circulars/?dt=${formattedDate}`)
      .then((response) => response.data)
      .then((data) => {
        setData(data.data);
      });
  };

  // Helper to get attachment URL safely
  const getAttachmentUrl = (attachment) => {
    console.log("attachment", attachment);
    if (!attachment) return "";
    try {
      // If already object, return url; if string, parse
      if (typeof attachment === "string") {
        const parsed = JSON.parse(attachment);
        return parsed?.url || "";
      } else if (typeof attachment === "object" && attachment !== null) {
        return attachment.url || "";
      }
    } catch (e) {
      // If parsing fails, fallback
      return "";
    }
    return "";
  };

  return (
    <div className="circular">
      {display1 ? (
        <Circular_Form
          setDisp={() => {
            setDisplay1(0);
          }}
          data={editData}
          isEdit={isEdit}
          setEdit={() => {
            setIsEdit(false);
          }}
          //change
          onSuccess={fetchCirculars}
        />
      ) : null}
      {del ? (
        <DeleteCard
          del={() => {
            handleDelete(delId);
          }}
          close={() => {
            setDel(0);
          }}
        />
      ) : null}
      <div className="circular__top">
        <div className="circular__top_button">
          {/* <input type="date" name="" id="" /> */}
          <div className="filter-container">
            <div
              className="datepicker-container"
              style={{ marginTop: '-2px', marginLeft: '0px' }}
            >              {/* <p>From:</p> */}
              {/* <DatePicker
                selected={startDate}
                className="datepicker"
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
              /> */}
            <input
  type="date"
  name=""
  className="datepicker"
  value={startDate ? moment(startDate).format("YYYY-MM-DD") : ""}
  onChange={(e) => {
    setStartDate(e.target.value ? new Date(e.target.value) : null);
  }}
  placeholder="mm-dd-yyyy"
/>
            </div>
            {/* <div className="datepicker-container">
              <p>To:</p>
              <input
                type="date"
                name=""
                className="datepicker"
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
              />
            </div> */}
          </div>
          {/* <button type="button" className="circular__top_button_date">
            <img
              className="circular__top_button_date_img"
              src={calendar}
              alt="upload"
            />
            Date
          </button> */}
        </div>
        <div className="circular__top_button">
          <button
            type="button"
            className="circular__top_button_go"
            onClick={handleFilter}
          >
            Go
          </button>
          <button
            type="button"
            className="circular__top_button_go"
            onClick={() => {
              // window.location.reload();
              setData([]);
              setStartDate("");
              setSortBy("asc");
              setEditData({});
              setIsEdit(false);
              setDel(0);
              setDelId(0);
              fetchCirculars();
            }}
          >
            Clear
          </button>
        </div>
        <div className="circular__top_button_left_most">
          <button
            type="button"
            className="circular__top_button_circular circular__top_button_go"
            onClick={() => setDisplay1(1)}
          >
            Add Circular
          </button>
        </div>
      </div>
      <div className="circular__middle">
        <table>
          <thead>
            <tr className="circular__middle_tr">
              <th className="circular__middle_th">
                Date{" "}
                {sortBy === "asc" ? (
                  <img
                    src={uparrow}
                    alt="uparrow"
                    style={{
                      height: 20,
                      width: 20,
                      marginBottom: -5,
                      marginLeft: 10,
                    }}
                    onClick={() => {
                      setSortBy("desc");
                    }}
                  />
                ) : (
                  <img
                    src={downarrow}
                    alt="downarrow"
                    style={{
                      height: 20,
                      width: 20,
                      marginBottom: -5,
                      marginLeft: 10,
                    }}
                    onClick={() => {
                      setSortBy("asc");
                    }}
                  />
                )}
              </th>
              <th className="circular__middle_th">Title</th>
              <th className="circular__middle_th">Notice</th>
              <th className="circular__middle_th">Attachment</th>
              <th className="circular__middle_th" />
            </tr>
          </thead>
          <tbody>
            {sortedData &&
              sortedData.map((data) => {
                const attUrl = getAttachmentUrl(data.attachment);
                console.log("Attachment URL:", attUrl);
                const handleForcedDownload = async (url, filename) => {
                  try {
                    const response = await fetch(url, { mode: "cors" });
                    if (!response.ok) throw new Error("Network response was not ok");
                    const blob = await response.blob();
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = blobUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(blobUrl);
                  } catch (error) {
                    console.error("Download failed:", error);
                    toast.error("Failed to download file");
                  }
                };

                return (
                  <tr className="circular__middle_tr" key={data.id}>
                    <td className="circular__middle_td">
                      {data.created ? moment(data.created).format("DD-MM-YYYY") : "-"}
                    </td>

                    <td className="circular__middle_td">
                      {data.title || "-"}
                    </td>

                    <td
                      className="circular__middle_td"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      {data.notice || "-"}
                    </td>

                    <td className="circular__middle_td">
                      {attUrl ? (
                        <>
                          <span style={{ marginRight: 10 }}>
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={attUrl}
                              style={{
                                color: "green",
                                textDecoration: "underline",
                                cursor: "pointer",
                               
                              }}
                            >
                              View
                            </a>
                          </span>
                          <a
                              href={attUrl}
                              target="_blank"
                            // onClick={() =>
                            //   handleForcedDownload(attUrl, `circular-${data.title || "file"}.png`)
                            // }
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                              cursor: "pointer",
                              background: "none",
                              border: "none",
                              padding: 0,
                              font: "inherit",
                            }}
                          >
                            Download
                          </a>
                          {/* <a
                            href={attUrl}
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            download={`circular-${data.title || "file"}.pdf`}
                          >
                            Download
                          </a> */}
                        </>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td className="circular__middle_td">
                      <button
                        type="button"
                        className="circular__middle_td_edit"
                        onClick={() => {
                          setIsEdit(true);
                          setEditData(data);
                          setDisplay1(1);
                        }}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setDel(1);
                          setDelId(data.id);
                        }}
                        className="circular__middle_td_delete"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor:
              pagination.page === pagination.totalPages
                ? "not-allowed"
                : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>

        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            id="limit-select"
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: Number(e.target.value),
                page: 1,
              }));
            }}
            style={{
              padding: "5px",
              borderRadius: "4px",
              border: "1px solid #ccc",
               backgroundColor:"rgb(239,239,239)",
              
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Circular;